module.exports = __webpack_public_path__ + "static/media/5.22_preview.89e58119.png";